import { Message } from "components/actions/response";
import i18n from "components/i18n/i18n";
import { Notyf, NotyfEvent } from "notyf";
import "notyf/notyf.min.css";
import "./sislogNotify.scss";

export class SingletonNotyf {

    private static instance: SingletonNotyf;

    private notyf = new Notyf({
        duration: 5000,
        dismissible: false,
        ripple: true,
        position: {
            x: "right",
            y: "top",
        },
        types: [
            {
                type: "info",
                className: "common-notify info-notify",
                icon: {
                    className: "fas fa-info",
                    tagName: "i",
                },
            },
            {
                type: "warn",
                className: "common-notify warn-notify",
                duration: 8000,
                icon: {
                    className: "fas fa-exclamation-triangle",
                    tagName: "i",
                },
            },
            // El tipo 'success', 'error' no deja sobreescribir los estilos,
            // de ahi que se creemos obj propios para estos tipos
            {
                type: "success-sislog",
                className: "common-notify sucess-notify",
                icon: {
                    className: "fas fa-check-circle",
                    tagName: "i",
                },
            },
            {
                type: "error-sislog",
                className: "common-notify error-notify",
                duration: 0,
                dismissible: true,
                icon: {
                    className: "fas fa-exclamation-circle",
                    tagName: "i",
                },
            }]
    });


    public static getInstance(): SingletonNotyf {
        if (document.querySelector("body > div.notyf") == null) {
            SingletonNotyf.instance = new SingletonNotyf();
        }

        return SingletonNotyf.instance;
    }

    private getNotyfObj() {
        return SingletonNotyf.instance.notyf;
    }

    private getTypeNotify(message: Message): string {
        // El tipo 'success', 'error' no deja sobreescribir los estilos,
        // de ahi que se creemos obj propios para estos tipos
        if ((message.level === "success") || (message.level === "error")) {
            return message.level + "-sislog";
        } else {
            return message.level;
        }
    }

    public show(message: Message) {

        const notyf = SingletonNotyf.getInstance().getNotyfObj();

        if (message.args != null && message.args !== undefined) {
            this.interpolateMessageArgs(message);
        }

        const notification = notyf.open({
            type: SingletonNotyf.getInstance().getTypeNotify(message),
            message: i18n.instance.t(message.key, message.args)
        });

        notification.on(NotyfEvent.Dismiss, ({ target, event }) => {
            if ((<KeyboardEvent>window.event).ctrlKey) {
                notyf.dismissAll();
            }
        });
    }

    private interpolateMessageArgs(message: Message): void {
        Object.keys(message.args).forEach(key => {
            let value = message.args[key];
            if (typeof value === 'string') {
                // 1 Si existe el literal se interpola tal cual
                if (i18n.instance.exists(value)) {
                    value = i18n.instance.t(value);
                    //Si viene sin ns el arg, se chequea si con el del la clave existe
                } else if (message.key.includes(":")) {
                    const ns = message.key.substring(0, message.key.indexOf(":"));
                    const new_value = ns + ":" + value;
                    if (i18n.instance.exists(new_value)) {
                        value = i18n.instance.t(new_value);
                    }

                }
                message.args[key] = value;
            }
        });
    }
}
